import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Zoom, { ZoomProps } from '@mui/material/Zoom';

///
/// Types
///
type TfnCallback = (bln: boolean) => void
type TfnAbrir    = (title: string, msg: string, callback: TfnCallback) => void;
type TfnFechar   = () => void;

const Transition = React.forwardRef<HTMLDivElement, ZoomProps>((props, ref) => (
	<Zoom ref={ref} {...props} />
));

///
/// Delegate
///
export interface IAlertConfirmDelegate {
	abrir: TfnAbrir;
	fechar: TfnFechar;
}

class AlertConfirmDelegate implements IAlertConfirmDelegate
{
	abrir: TfnAbrir;
	fechar: TfnFechar;

	constructor(abrir: TfnAbrir, fechar: TfnFechar)
	{
		this.abrir = abrir;
		this.fechar = fechar;
	}
}

///
/// Componente
///
export interface IProps
{
	getDelegate: (delegate: IAlertConfirmDelegate) => void
}

const AlertDialog : React.FC<IProps> = (props) =>
{
	///
	/// States
	///
	const [open, setOpen] = React.useState(false);
	const [title, setTitle] = React.useState("");
	const [content, setContent] = React.useState("");
	const [callBack, setCallback] = React.useState<TfnCallback>();

	///
	/// Ações
	///
	const fnOpen = React.useCallback<TfnAbrir>((title: string, msg: string, callback: TfnCallback) =>
	{
		setCallback( () => callback)
		setTitle(title)
		setContent(msg)
		setOpen(true)
	}, [])

	const fnClose = React.useCallback((event?: React.SyntheticEvent, reason?: "backdropClick" | "escapeKeyDown") =>
	{
		// if (reason === 'escapeKeyDown')  return;
		setOpen(false);
	}, []);

	const fnAnswered = React.useCallback<TfnCallback>( (bln: boolean) =>
	{
		console.log("fnAnswered, bln: ", bln)
		console.log(callBack);
		callBack && callBack(bln);
		setOpen(false);
	}, [callBack])

	///
	/// Delegate
	///
	React.useEffect(()=>{
		// console.log("AAAA")
		// console.log(props.getDelegate)
		props.getDelegate(new AlertConfirmDelegate(fnOpen, fnClose));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	///
	/// Render
	///
	return (
		<>
		<BootstrapDialog
			open={open}
			onClose={fnClose as any}
			TransitionComponent={Transition}
			transitionDuration={500}
		>
			<DialogTitle sx={{px:2}}>{title}</DialogTitle>
			<IconButton onClick={() => fnAnswered(false)} sx={{ position:'absolute', right:16, top:12 }} aria-label="Fechar" color="default">
         	<CloseIcon />
        	</IconButton>
			<DialogContent sx={{px:2}} dividers>
				<DialogContentText id="alert-dialog-description">{content}</DialogContentText>
			</DialogContent>
			<DialogActions>
			<>
				<Button onClick={() => fnAnswered(true)}  size="large" variant="contained" color="primary" type="submit">Sim</Button>
				<Button onClick={() => fnAnswered(false)} size="large" variant="outlined"  color="primary" type="submit">Não</Button>
			</>
			</DialogActions>
		</BootstrapDialog>
		</>
	);
}
export default AlertDialog

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogActions-spacing': {
		padding: theme.spacing(2),
	},
}));

const BootstrapDialogActions = styled(DialogActions)(({ theme }) => ({
}));
